import React from 'react'
import { Link } from 'react-router-dom'
import MessageUI from './MessageUI'
import './TopNavLink.css'

const TopNavLinkUI = ({messageList, labelKey, label, to, active}) =>
  <>
    {
      !to.startsWith('https') &&
      <Link to={to} className={`w_top_nav g_no_wrap_2 ${active ? 'active' : ''}`}>
        {
          label &&
          <span>{label}</span>
        }
        {
          !label &&
          <MessageUI messageList={messageList} messageKey={labelKey} />
        }
      </Link>
    }
    {
      to.startsWith('https') &&
      <a href={to} className='w_top_nav g_no_wrap_2' target='_blank'>{label}</a>
    }
  </>

export default TopNavLinkUI
